import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPython } from "@fortawesome/free-brands-svg-icons";
import { Row, Col } from "reactstrap";

const schemeMap = {
  Python: { primary: '#3776ab', secondary: '#ffd43b', icon: faPython },
};

const ProgrammingButton = ({ structure, onButtonClick, progress = 0 }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const scheme = schemeMap[structure.name] ?? { primary: '#666', secondary: '#999', icon: faPython };

  const getProgressWidth = (value) => {
    if (value > 100) return "100%";
    if (value >= 98) return "100%";
    if (value === 0) return "0%";
    return Math.max(value, 8) + "%";
  };

  return (
    <div style={{ width: "220px", }}>
      <button
        className="ds-button"
        onClick={() => onButtonClick(structure.name)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          background: `linear-gradient(135deg, ${scheme.primary}15 0%, ${scheme.secondary}10 100%)`,
          // border: isHovered ? `1px solid ${scheme.primary}30` : "none",
          // boxShadow: `0 10px 20px -8px ${scheme.primary}20`,
        }}
      >
        {/* Animated background overlay */}
        <div
          style={{
            position: 'absolute',
            inset: '0',
            background: `linear-gradient(135deg, ${scheme.primary}${isHovered ? '25' : '10'} 0%, ${scheme.secondary}${isHovered ? '20' : '08'} 100%)`,
            transition: 'all 0.4s ease',
            borderRadius: '24px',
          }}
        />

        {/* Icon container */}
        <Col
          style={{
            position: 'relative',
            zIndex: 10,
            width: "60px",
            height: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "16px",
            background: `linear-gradient(135deg, ${scheme.primary} 0%, ${scheme.secondary} 100%)`,
            // boxShadow: `0 8px 25px -5px ${scheme.primary}40`,
            marginBottom: "16px",
            transform: isHovered ? 'scale(1.1) rotate(5deg)' : 'scale(1) rotate(0deg)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          <FontAwesomeIcon
            icon={scheme.icon}
            style={{ fontSize: "28px", color: "white" }}
          />
        </Col>

        {/* Label */}
        <span
          className="button-label"
          style={{
            position: 'relative',
            zIndex: 10,
            fontFamily: '"Inter", "Poppins", sans-serif',
            letterSpacing: "0.5px",
            fontSize: "20px",
            fontWeight: "700",
            background: `linear-gradient(135deg, ${scheme.primary} 0%, ${scheme.secondary} 100%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            display: 'block',
            marginBottom: "16px",
            textAlign: 'center',
            width: '100%',
          }}
        >
          {structure.name}
        </span>

        {/* Progress section */}
        <Row style={{ position: 'relative', zIndex: 10, width: '100%' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '8px',
            width: '100%',
          }}>
            <span className="progress-label" style={{ color: scheme.primary }}>
              Progress
            </span>
          </div>
          <div style={{
            width: "100%",
            height: "14px",
            borderRadius: "10px",
            position: "relative",
            backgroundColor: `${scheme.primary}20`,
            overflow: "hidden",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              width: getProgressWidth(progress),
              background: `linear-gradient(90deg, ${scheme.primary} 0%, ${scheme.secondary} 100%)`,
              height: "100%",
              borderRadius: "10px",
              transition: "all 0.7s ease-out",
              boxShadow: `0 0 10px ${scheme.primary}40`,
              transform: isHovered ? 'scaleY(1.5)' : 'scaleY(1)',
              position: 'absolute',
              left: '0',
              top: '0',
            }} />
            <span style={{
              fontSize: '12px',
              fontWeight: '700',
              color: progress > 30 ? 'white' : scheme.primary,
              fontFamily: '"Inter", sans-serif',
              position: 'relative',
              zIndex: 1,
              textShadow: progress > 30 ? '0 1px 2px rgba(0,0,0,0.5)' : 'none',
              lineHeight: '1',
            }}>
              {Math.round(progress) >= 98 ? "100" : Math.round(progress)}%
            </span>
          </div>
        </Row>

        {/* Hover glow effect */}
        <div
          style={{
            position: 'absolute',
            inset: '0',
            borderRadius: '24px',
            opacity: isHovered ? '1' : '0',
            transition: 'opacity 0.3s ease',
            background: `radial-gradient(circle at center, ${scheme.primary}15 0%, transparent 70%)`,
          }}
        />
      </button>
    </div>
  );
};

const ProgrammingButtons = ({ structures = [], onButtonClick, getProgress }) => {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    }}>
      <div style={{
        display: "flex",
        gap: "20px",
        flexWrap: "wrap",
        justifyContent: "center",
        marginBottom: "20%",
      }}>
        {structures.map((structure) => (
          <ProgrammingButton
            key={structure.id}
            structure={structure}
            onButtonClick={onButtonClick}
            progress={
              typeof getProgress === "function"
                ? getProgress(structure.id) ?? 0
                : 0
            }
          />
        ))}
      </div>
    </div>
  );
};

export default ProgrammingButtons;